import {Inject, Injectable} from '@angular/core';
import {Newable, PersistenceService} from '../../persistence.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DataObject} from '../../../models/data-object.model';
import Config from '../../db.config.json';

@Injectable()
export class MongodbService extends PersistenceService {

    private baseURL = Config.mongodb.server + ':' + Config.mongodb.port + '/' + Config.mongodb.dbname + '/';
    private readonly _headers = { headers: new HttpHeaders({
            'Content-Type': 'application/json'
    }) };

    constructor(@Inject(HttpClient) private http: HttpClient) {
        super();
    }

    create(data: DataObject): Observable<void> {
        // @ts-ignore .constructor is used for accessing static class members
        return this.http.post(this.baseURL + data.constructor.urlName, data.toJSON(), this._headers)
            .pipe(map((obj: any) => {
                data.id = obj._id;
                return;
            })
        );
    }

    get<T extends DataObject>(id: string, type: Newable<T>): Observable<T> {
        // @ts-ignore static access of underlying class not recognized
        return this.http.get<any>(this.baseURL + type.urlName + '/' + id).pipe(
            map((obj: any) => {
                return new type().fromJSON(obj) as T;
            })
        );
    }

    list<T extends DataObject>(type: Newable<T>): Observable<T[]> {
        // @ts-ignore static access of underlying class not recognized
        return this.http.get<any[]>(this.baseURL + type.urlName).pipe(
            map((data: any[]) => {
                const dataObjects = [];
                data.forEach((obj) => {
                    obj.id = obj._id;
                    // @ts-ignore: new object needs to be constructed
                    // expression not recognized as constructable
                    dataObjects.push(new type().fromObject(obj));
                });
                return dataObjects;
            })
        );
    }

    update(data: DataObject): Observable<any> {
        // @ts-ignore .constructor is used for accessing static class members
        return this.http.put(this.baseURL + (data.constructor).urlName + '/' + data.id,
                             data.toJSON(), this._headers);
    }

    delete<T extends DataObject>(id: string, type: Newable<T>): Observable<any> {
        // @ts-ignore static access of underlying class not recognized
        return this.http.delete(this.baseURL + type.urlName + '/' + id,
                                this._headers);
    }

}
